let getSessionTokens = () => null

export function configureTaskSkillSession(provider) {
  getSessionTokens = provider
}

export function taskSkillSessionHeaders() {
  const token = getSessionTokens()?.session_jwt
  if (!token) throw new Error('Sign in again to use Alfred tasks.')
  return { Authorization: `Bearer ${token}` }
}
